export default "__VITE_ASSET__DfjxZWMz__"